import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_RESOURCES';
export const single = 'SINGLE_RESOURCE';

export const resourcesApi = createApi({
  reducerPath: 'resourcesApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    createResources: builder.mutation({
      query: (resource) => ({
        url: '/resources/create',
        method: 'POST',
        body: resource
      }),
      invalidatesTags: [list]
    }),
    listResources: builder.query({
      query: (params) => ({
        url: '/resources/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    })
  })
});

export const { useCreateResourcesMutation, useListResourcesQuery } = resourcesApi;
